import { motion } from "framer-motion";
import { useLocation, Link } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

const pageMeta = {
  "/dashboard/media":        { title: "Media Library",        desc: "Upload and manage photos, videos, and files for your listing." },
  "/dashboard/content":      { title: "Content Publishing",   desc: "Create and publish blog posts, updates, and promotions." },
  "/dashboard/inventory":    { title: "Inventory",            desc: "Manage your product and service inventory for the marketplace." },
  "/dashboard/reviews":      { title: "Reviews",              desc: "Monitor and respond to customer reviews." },
  "/dashboard/pixels":       { title: "Retargeting & Pixels", desc: "Configure Meta, Google, and other tracking pixels for your listing." },
  "/dashboard/embeds":       { title: "Embeds",               desc: "Generate embed codes to display your listing on other websites." },
  "/dashboard/team":         { title: "Team Members",         desc: "Invite team members and manage permissions." },
  "/dashboard/billing":      { title: "Billing",              desc: "Manage your subscription, payment methods, and invoices." },
  "/dashboard/integrations": { title: "Integrations",         desc: "Connect third-party services like CRM, email, and analytics." },
};

export default function DashboardComingSoon() {
  const location = useLocation();
  const meta = pageMeta[location.pathname] || { title: "Feature", desc: "This feature is under development." };

  return (
    <div className="flex items-center justify-center min-h-[60vh]" data-testid="dashboard-coming-soon">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="text-center max-w-md"
      >
        <div className="w-20 h-20 rounded-2xl bg-[#7C3AED]/10 border border-[#7C3AED]/20 flex items-center justify-center mx-auto mb-6">
          <Lock className="w-9 h-9 text-[#7C3AED]" />
        </div>
        <h1 className="text-2xl font-bold text-white font-['Outfit'] mb-2">
          {meta.title}
        </h1>
        <p className="text-[#94A3B8] mb-2">
          {meta.desc}
        </p>
        <div className="inline-block px-3 py-1 bg-[#F59E0B]/10 text-[#F59E0B] rounded-full text-sm font-medium mb-6">
          Coming Soon
        </div>
        <p className="text-sm text-[#64748B] mb-6">
          This feature is part of an upcoming release. Check back soon!
        </p>
        <Link to="/dashboard">
          <Button variant="outline" className="border-white/20 text-white hover:bg-white/5">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Dashboard
          </Button>
        </Link>
      </motion.div>
    </div>
  );
}
